// extracted by mini-css-extract-plugin
module.exports = {"root":"app_root__2x7li","main":"app_main__1BEhW","sidebar":"app_sidebar__1BnjL"};